/*
	OneVideo 2.0.0 Usage (Webpack)
	Yang @onerockwell
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import Player from '@vimeo/player';

import '../../styles/modules/oneVideo.scss';

// Define the Backbone View here (Optional)
let OneVideoView = Backbone.View.extend({
	
	initialize: function (settings) {
		var self = this;
		self.$videoBoxes = self.$el;
		self.isResponsive = settings.isResponsive || false;
		self.bgVideo = settings.bgVideo || false;
		self.alwaysVisible = settings.alwaysVisible || false;
		self.autoplay = settings.autoplay || false;
		self.hasSound = settings.hasSound || false;
		self.showVideoOnPause = settings.showVideoOnPause || false;
		
		self.initVideos();
	},

	events: {

	},
	
	initVideos: function() {
		var self = this;
		
		_.each(self.$videoBoxes, function(box){
			var $box = $(box);
			var boxId = $box.attr('id');
			var type = $box.data('video-type');
			var videoId = $box.data('video-id');
			var videoSrc = $box.data('video-src');
			if(self.bgVideo || self.alwaysVisible){
				self.loadHostPlayer(videoId,videoSrc,$box,boxId);
			}else if(type == "vimeo"){
				self.loadVimeoPlayer(videoId,videoSrc,$box,boxId);
			}
		});
	},
	
	loadHostPlayer: function(video_id,video_src,$video_box,video_box_id){
		// Works for vimeo or self-hosted videos
		var self = this, id = '', $videoWrapper = $video_box;
		var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
		var $playerCtl = $videoWrapper.find('.video-ctl');

		var responsive = function(r){
			var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
			if (wrapperRatio >= r) {
				$videoWrapper.find('video').css({
					'width' : '100%',
					'height': $videoWrapper.width()/r
				});
			} else {
				$videoWrapper.find('video').css({
					'height' : '100%',
					'width': $videoWrapper.height()*r
				});
			}
		};
		
		if(self.autoplay){
			var $video = $('<video preload="metadata" loop muted autoplay playsinline><source src="' + video_src + '" type="video/mp4"></video>');
		}else if (self.hasSound) {
			var $video = $('<video preload="metadata" loop playsinline><source src="' + video_src + '#t=0.1' + '" type="video/mp4"></video>');
		}else{
			var $video = $('<video preload="metadata" loop muted playsinline><source src="' + video_src + '#t=0.1' + '" type="video/mp4"></video>');
		}
		$playerCtl.text('Play');
		$video_box.prepend($video);
		
		var theVideo = $video[0]; 
		theVideo.muted = true;
		if (self.hasSound) {
			theVideo.muted = false;
		}
		if (self.alwaysVisible) { // Load visible initially
			$video_box.find('video').css({
				'visibility': 'visible',
				'opacity': '1'
			});
		}

		var ctlTimer;

		var ctlHide = function() {
			if ($video.isPlaying) {
				clearTimeout(ctlTimer);
				ctlTimer = setTimeout(function() {
					$playerCtl.css({
						'visibility': 'hidden',
						'opacity': '0'
					})
				}, 2000);
			};
		}

		var ctlShow = function(fade) {
			if ($video.isPlaying) {
				clearTimeout(ctlTimer);
					$playerCtl.css({
						'visibility': 'visible',
						'opacity': '1'
				});
				if (fade) {
					ctlHide();
				}
			}
		}

		$video.on('play', function() {
			$video.isPlaying = true;
			$playerCtl.text('Pause');
			$playerCtl.removeClass('paused').addClass('playing');
			$video.isPlaying = true;
			$video_box.find('video').css({
				'visibility': 'visible',
				'opacity': '1'
			});
			$video_box.parent('.image-wrapper').addClass('video-playing');
			if ($playerCtl.length) {
				ctlHide();
			}
			// console.log('play the video!');
		});
		$video.on('pause', function() {
			$video.isPlaying = false;
			$playerCtl.text('Play');
			$playerCtl.removeClass('playing').addClass('paused');
			$video.isPlaying = false;
			if(!self.autoplay && self.bgVideo){
				if (!self.showVideoOnPause) {
					$video_box.find('video').css({
						'visibility': 'hidden',
						'opacity': '0'
					});
				}
			}
			$video_box.parent('.image-wrapper').removeClass('video-playing');
			clearTimeout(ctlTimer);
			// console.log('pause the video!');
		});

		function toggleVideo(){
			if ($video.isPlaying) {
				theVideo.pause();
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
			} else {
				theVideo.play();
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
			}
		}

		$video.on('click', function(){
			toggleVideo();
		});
		
		if ($playerCtl.length) {
			$playerCtl.text('Pause');
			// $playerCtl.removeClass('paused').addClass('playing');
			$playerCtl.on('click', function(){
				toggleVideo();
			});

			var $video_box_inner = $video_box.find('.content-wrapper');
			$video_box_inner.on('mouseenter click', function(event) {
				ctlShow(true);
			});
			$video_box_inner.on('mouseleave', function(event) {
				ctlHide();
			});
		}
		
		$video.on('bufferend', function(){
			console.log("video buffered");
			if (self.isResponsive) {
				responsive(videoRatio);
			}
			console.log('init video');
		});
		
		if (self.isResponsive) {
			$(window).resize(function() {
				clearTimeout(id);
				id = setTimeout(function(){
					responsive(videoRatio);
				}, 400);
			});
		}
	},
	
	loadVimeoPlayer: function(video_id,video_src,$video_box,video_box_id){
		var self = this, id = '', $videoWrapper = $video_box;
		var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
		var $playerCtl = $videoWrapper.siblings('.video-ctl');
		var responsive = function(r){
			var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
			// console.log(wrapperRatio + '/' + r);
			if (wrapperRatio >= r) {
				$videoWrapper.find('iframe').css({
					'width' : '100%',
					'height': $videoWrapper.width()/r
				});
			} else {
				$videoWrapper.find('iframe').css({
					'height' : '100%',
					'width': $videoWrapper.height()*r
				});
			}
		};
		
		if (self.isMobile()) {
			var options = {
				// id: video_id,
				byline: false,
				portrait: false,
				title: false,
				loop: false,
				background: true
			};
			var vmplayer = new Player(video_box_id, options);
		} else {
			var $iframe = $('<iframe frameborder="0" src="' + video_src + '?title=0&amp;byline=0&amp;portrait=1&amp;autoplay=1&amp;loop=1&amp;controls=0&amp;background=1">');
			$video_box.html($iframe);
			var vmplayer = new Player($iframe); 
		}
		
		if ($playerCtl.length) {
			
			if (!self.isMobile()) {
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
				$playerCtl.on('click', function(){
					if (vmplayer.isPlaying) {
						vmplayer.pause();
						$playerCtl.text('Play');
						$playerCtl.removeClass('playing').addClass('paused');
					} else {
						vmplayer.play();
						$playerCtl.text('Pause');
						$playerCtl.removeClass('paused').addClass('playing');
					}
				})
			} else {
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
				$playerCtl.on('click', function(){
					if (vmplayer.isPlaying) {
						vmplayer.pause();
					}
					vmplayer.play();
				})
			}
			
		}
		
		vmplayer.setVolume(0);
		vmplayer.on('play', function() {
			vmplayer.isPlaying = true;
			if (self.isMobile()) {
				$video_box.find('iframe').css({
					'opacity' : '1'
				})
				$playerCtl.css({
					'z-index' : '3'
				});
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
			}
			console.log('played vm video!');
		});
		vmplayer.on('pause', function() {
			vmplayer.isPlaying = false;
			if (self.isMobile()) {
				$video_box.find('iframe').css({
					'opacity' : '0'
				});
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
			}
			console.log('pause vm video!');
		});
		vmplayer.on('loaded', function() {
			if (self.isResponsive) {
				responsive(videoRatio);
			}
			console.log('init vm video');
		});
		
		if (self.isResponsive) {
			$(window).resize(function() {
				clearTimeout(id);
				id = setTimeout(function(){
					responsive(videoRatio);
				}, 400);
			});
		}
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	},

	isMobile: function () {
		if ( ORW.responsive == 'small') {
			return true;
		}
		return false;
	},

	isDesktop: function () {
		if ( ORW.responsive == 'large') {
			return true;
		}
		return false;
	}
	
});

// Define the module here 
let OneVideo = {
	init: function (settings) {
		return new OneVideoView(settings);
	}
}

// Output the module
export default OneVideo;